<template>
  <div class="flex flex-col flex-col-reverse md:flex-row" :class="photos === 'Upload' || photos === 'photo' ? 'h-full md:h-screen overflow-auto md:overflow-hidden' : ''">
    <div v-show="openAlertModal && enableAlertModalShowing" class="flex justify-center items-center absolute z-20 bg-gray-500 bg-opacity-30 h-screen w-full">
      <AlertModal :alertText="alertText" @close="closeAlertModal"/>
    </div>
    
    <div v-if="cropperModal && imageSrc" class="flex justify-center items-center fixed top-0 left-0 z-20 bg-gray-500 bg-opacity-30 h-screen w-full">
      <ImageCropperModal :imgSrc="imageSrc" @closeModal="closeCropperModal" @crop="onImageCrop"/>
    </div>

    <transition name="fade">
      <div v-if="loading" class="bottom-0 mb-5 flex justify-center absolute h-20 w-full">
        <LoadingModal :loadingText="loadingMessage" :loadingBarSize="1500"/>
      </div>
    </transition>
    

    <div v-if="uploadedVideoDuration > videoRestriction.duration || uploadedVideoAudioChannels > videoRestriction.maxAudioChannels" class="flex justify-center items-center absolute z-20 bg-gray-500 bg-opacity-30 h-full w-full">
      <UploadedVideoModal v-if="uploadedVideoDuration > INSTAGRAM_VIDEO_RESTRICTION || uploadedVideoAudioChannels > 2" 
        :buttons="[{message: 'Remove video', event: 'remove'}, {message: 'Select another video', event: 'change'}, {message: 'Remove instagram accounts', event: 'remove-instagram-accounts'}]" 
        :initialText="'The video duration does not fulfills the duration restriction'"
        @change="changeSelectedPhoto"
        @remove="deleteSelectedVideo"
        @remove-instagram-accounts="removeInstagramAccounts"/>
      
      <UploadedVideoModal v-else 
      :buttons="[{message: 'Remove video', event: 'remove'}, {message: 'Select another video', event: 'change'}]" 
      :initialText="'The video duration does not fulfills the duration restriction'"
      @change="changeSelectedPhoto"
      @remove="deleteSelectedVideo"/>
    </div>
    <!--Left Side-->
    
     <!--Toggle-->
    <div :class="photos == 'MyMedia' ? 'md:mt-36' : 'md:mt-48'" class="w-full md:w-6/12 px-4 md:px-20 py-8 md:py-16 h-full bg-platinumMild mt-0">
      <div :class="photos == 'MyMedia' ? 'pt-8' : 'py-8'" class="w-full md:w-1/2 md:px-20 px-0 bg-platinumMild block md:fixed top-0 left-0 z-10">
        <h2 class="hidden md:block text-3xl font-semibold mb-10">Upcoming Post</h2>
        <div class="flex flex-col-reverse md:flex-row items-start md:items-center justify-center">
          <div class="w-full h-11 bg-payne bg-opacity-10 relative flex items-center rounded-lg mb-4 md:mb-10">
            <div @click="changeShowing('Media')" class="flex z-10 w-4/12  items-center justify-center">
              <a class=" text-center text-gray-500 text-sm mr-2 cursor-pointer">Tithe.ly Media </a>
              <MediaArrow class="hidden md:block"/>
            </div>
            <a @click="changeShowing('MyMedia')" class="z-10 w-4/12 text-center text-gray-500 text-sm cursor-pointer">My Media</a>
            <div @click="changeShowing('Upload')" class="flex items-center justify-center z-10 w-4/12">
              <PlusIcon class="w-3 h-3 mr-3 text-gray-600 hidden md:block"/>
              <a class="text-center text-gray-500 text-sm cursor-pointer">Upload Files</a>
            </div>
            <div :class="photos == 'Upload' ? 'transform translate-x-full' : photos == 'MyMedia' || photos == 'my-media-photo' ? 'transform translate-x-1/2' : 'transform translate-x-0'" class="w-8/12 h-full absolute transition transform ease-out">
              <div class="w-1/2 h-full bg-white shadow-lg rounded-lg"></div>
            </div>
          </div>

          <div @click="toggleFavorite" class="mb-4 md:mb-10 ml-0 md:ml-4 cursor-pointer">
            <HeartEnabledIcon v-if="favoriteFilterEnabled" />
            <HeartDisabledIcon v-else />
          </div>
        </div>
        
        <div v-if="photos == 'Media'" class="flex flex-col md:flex-row rounded-lg bg-white border-2 border-gray-100 ">
          <div class="relative w-full flex items-center">
            <input @keydown.enter="addFilter('name', $event)" v-model="nameFilter" class="w-full focus:outline-none border-none text-sm rounded-md" placeholder="Search" type="text">
            <SearchIcon v-on:click.native="searchClicked('name')" class="absolute right-3 text-gray-500 cursor-pointer"/>
          </div>
        </div>
      </div>

      <div v-show="photos == 'Media'" class="w-full mt-8">
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <PostItem v-on:clicked="showPhotos" class="mb-4" :item="item" v-for="item in allMedia" :key="'item ' + item.id"/>
        </div>
        <infinite-loading v-show="!disableInfiniteLoader" ref="infiniteLoaderMedia" @infinite="loadMore">
            <div slot="spinner" class="items-grid mt-8">
              <item-skeleton v-for="item in 4" :key="`media-skeleton-item-${item}`"/>
            </div>
            <div slot="no-more" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
            <div slot="no-results" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
        </infinite-loading>
      </div>

      <div v-show="photos == 'MyMedia'" class="w-full">
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <PostMyMediaItem v-for="item in allMyMedia" :key="'my-media-item ' + item.id" v-on:clicked="showPhotos" class="mb-4" :item="item" />
        </div>
        <infinite-loading v-show="!disableInfiniteLoader" ref="infiniteLoaderMyMedia" @infinite="loadMoreMyMedia">
            <div slot="spinner" class="items-grid mt-8">
              <item-skeleton v-for="item in 4" :key="`my-media-skeleton-item-${item}`"/>
            </div>
            <div slot="no-more" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
            <div slot="no-results" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
        </infinite-loading>
      </div>

      <div v-if="photos == 'Upload' && !(croppedImage || videoFile)" @click="$refs['media-input'].click()" @drop.prevent="uploadMediaDrag" @dragover.prevent class="flex flex-col mt-8 h-96 justify-center items-center w-full border-dashed border-gray-400 border-2 rounded-lg cursor-pointer">
          <Upload/>
          <h2 class="font-semibold text-2xl text-customGrayDark">Drag files here</h2>
          <p class="text-sm text-customGray">or<span class="text-customGrayDark"> Browse Files </span>from your computer.</p>
      </div> 

      <div v-if="photos == 'Upload' && (croppedImage || videoFile)" class="w-full">
          <div v-show="croppedImage" class="relative">
            <div @click="deleteCropperdImage" class="flex justify-center items-center absolute -right-3 -top-3 bg-white rounded-full w-10 h-10 shadow-lg text-payneFire cursor-pointer"><XIcon/></div>   
            <img :src="croppedImage" class="w-full rounded-md"/>
          </div>

          <div v-show="videoFile" class="relative">
            <div @click="deleteSelectedVideo" class="flex justify-center items-center absolute -right-3 -top-3 bg-white rounded-full w-10 h-10 shadow-lg text-payneFire cursor-pointer z-10"><XIcon/></div>   
            <video id="uploaded-video" autoplay muted loop class="w-full rounded-md" @durationchange="setUploadedVideoDuration($event)">
                <source :src="videoSrc">
            </video>
          </div>
      </div> 

      <input ref="media-input" type='file' @change="uploadMedia" hidden />

      <ItemPhotos v-if="photos == 'photo' || photos == 'my-media-photo' || photos == 'social-media' || photos == 'graphic' || photos == 'video'" :videoRestriction="videoRestriction" :item="item" :pictures="item.files" @back-to-media="changeShowing('Media')" :loading="loadingImageParse" @select-video="changeVideo" @select-photo="changePhoto" 
      @video-not-selectible="showVideoNotSelectibleMessage"
      @actual-video-audio-channels="changeVideoAudioChannels"/>
      
      <!-- <TablePaginator v-if="photos == 'Media'" :nextPageUrl="media.links.next ? media.links.next : ''" :prevPageUrl="media.links.prev ? media.links.prev : ''" @nextPage="visitPage" @prevPage="visitPage"/> -->
    </div>
    
    <div class="w-full md:w-6/12 px-4 mb-10 py-10 md:py-18 block md:fixed top-0 right-0 h-full md:h-screen overflow-y-scroll">
      <h2 class="block md:hidden text-3xl font-semibold mb-10 mt-5">Upcoming Post</h2>

      <inertia-link :href="$route('scheduler.posts.index')" > 
        <XIcon class="absolute right-10 top-10 w-5 h-5"/>
      </inertia-link>

      <p class="mb-2 mt-2 md:mt-16 font-semibold text-sm">Caption</p>

      <div class="w-full md:w-10/12">
        <TextareaEmojiPicker :text="form.caption" @captionChanged="changeCaption"/>
      </div>

      <p class="mb-2 font-semibold text-sm">Post Date</p>
      
      <div class="w-full">
        <DatePickerInput :initialDate="getDateWithTime()" @dateChanged="changeDate" :fromToday="true"/>
      </div>
      <div class="relative">
        <TagSelector @change-page="changePage" :pages="pages"/>
        <SubmitButtons @submitPost="submitPost" @submitPostNow="onSubmitPostNow" @submitSaveAsDraft="onSubmitSaveAsDraft"
          :disableConfirm="disableConfirmButton()" :disable="disableButton()" :newDate="newDate" :loading="loading" @mouseover="showError"/>
      </div>
      <transition name="fade">
        <div v-if="passedOverButton && getError()" class="bg-red-100 border border-red-400 text-red-700 rounded w-full md:w-5/6 relative p-2 mt-16 flex items-center">
          <InformationIcon class="mr-3 h-4 w-4" fill="#b91c1c"/>
          <span class="">{{ getError() }}</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import InfiniteLoading from 'vue-infinite-loading';

import TextareaEmojiPicker from "@/components/scheduler/Common/TextareaEmojiPicker";
import DatePickerInput from "@/components/scheduler/Common/DatePickerInput";
import PostItem from "@/components/scheduler/Common/PostItem";
import TagSelector from "@/components/scheduler/TagSelector";
import ItemPhotos from "@/components/scheduler/Common/ItemPhotos";
import ImageCropperModal from "@/components/scheduler/Common/ImageCropperModal";
import AlertModal from '@/components/scheduler/Common/AlertModal';
import LoadingModal from '@/components/scheduler/Common/LoadingModal';
import UploadedVideoModal from '@/components/scheduler/Common/UploadedVideoModal';
import TablePaginator from '@/components/scheduler/Table/Paginator';
import SubmitButtons from '@/components/scheduler/Common/SubmitButtons';
import ItemSkeleton from "@/components/shared/ItemSkeleton"

import MediaArrow from "@/components/svg/MediaArrow";
import SearchIcon from "@/components/svg/SearchIcon";
import XIcon from "@/components/svg/XIcon";
import InformationIcon from "@/components/svg/Information";
import Arrow from "@/components/svg/Arrow";
import Upload from '@/components/svg/Upload';
import BackArrow from '@/components/svg/BackArrow';
import PlusIcon from '@/components/svg/PlusIcon';
import PostMyMediaItem from '@/components/scheduler/Common/PostMyMediaItem';
import HeartEnabledIcon from '@/components/svg/HeartEnabledIcon';
import HeartDisabledIcon from '@/components/svg/HeartDisabledIcon';

var utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

export default {
  name: 'NewPost',

  components: {
    SearchIcon, 
    Arrow,
    MediaArrow,
    XIcon,
    TextareaEmojiPicker,
    DatePickerInput,
    TagSelector,
    Upload,
    PostItem,
    ItemPhotos,
    ImageCropperModal,
    TablePaginator,
    BackArrow,
    AlertModal,
    InformationIcon,
    SubmitButtons,
    UploadedVideoModal,
    InfiniteLoading,
    ItemSkeleton,
    LoadingModal,
    PlusIcon,
    PostMyMediaItem,
    HeartEnabledIcon,
    HeartDisabledIcon
  },
  
  remember: ['allMedia'],
  
  props: {
    media:{
      type:Object,
      require:true
    },

    myMedia:{
      type:Object,
      require:true
    },

    pages:{
      type:Array,
      require:true
    },

    flash: Object,

    filters: {
      type: Object,
      require: true
    },

    incomingFormData: {
      type: Object,
      require: true
    }
  },

  data () {
    return {
      FACEBOOK_VIDEO_RESTRICTION: 20,
      INSTAGRAM_VIDEO_RESTRICTION: 1,
      DEFAULT_VIDEO_RESTRICTION: 1000,
      photos: 'Media',
      allMedia: this.media.data,
      allMyMedia: this.myMedia.data,
      form: {
        caption: this.incomingFormData && this.incomingFormData.caption ? this.incomingFormData.caption : '',
        image_url: '',
        post_date: this.incomingFormData && this.incomingFormData.post_date ? this.incomingFormData.post_date : '',
        video_url: ''
      },
      item: {},

      videoDuation: 0,
      videoAudioChannels: 0,

      nameFilter: this.filters && this.filters.name ? this.filters.name : '',
      passedOverButton: false,
      loading: false,
      loadingImageParse: false,
      cropperModal: false,
      imageSrc: null,
      videoFile: null,
      videoSrc: null,
      uploadedVideoDuration: 0,
      uploadedVideoAudioChannels: 0,

      croppedImage: null,
      croppedImageFile: null,
      activeFilters: this.filters || {},
      buttonOver: null,

      openAlertModal: false,
      enableAlertModalShowing: true,
      alertText: '',

      loadingMessage: '',
      newDate:'',

      favoriteFilterEnabled: false,
      disableInfiniteLoader: false
    }
  },

  mounted() {
    if (!this.media.links.next) {
      this.$refs.infiniteLoaderMedia.stateChanger.loaded()
      this.$refs.infiniteLoaderMedia.stateChanger.complete()
    }

    if (!this.myMedia.links.next) {
      this.$refs.infiniteLoaderMyMedia.stateChanger.loaded()
      this.$refs.infiniteLoaderMyMedia.stateChanger.complete()
    }
  },

  methods: {
    loadMore($state) {
      if (!this.media.links.next) {
        return
      }

      this.$inertia.get(this.media.links.next, this.parsedFilters, {
        preserveState: true,
        preserveScroll: true,
        only: ['media'],
        onFinish: () => {
          this.$refs.infiniteLoaderMedia.stateChanger.loaded()
          if (!this.media.links.next) {
            this.$refs.infiniteLoaderMedia.stateChanger.complete()
          }
        }
      })
    },

    loadMoreMyMedia($state) {
      if (!this.myMedia.links || !this.myMedia.links.next) {
        return;
      }

      this.$inertia.visit(this.myMedia.links.next, {
        preserveState: true,
        preserveScroll: true,
        only: ['myMedia'],
        onFinish: () => {
          this.$refs.infiniteLoaderMyMedia.stateChanger.loaded()
          if (!this.myMedia.links.next) {
            this.$refs.infiniteLoaderMyMedia.stateChanger.complete()
          }
        }
      });
    },

    toggleFavorite() {
      this.favoriteFilterEnabled = !this.favoriteFilterEnabled;
      
      this.allMedia = [];
      this.allMyMedia = [];

      if(this.favoriteFilterEnabled) {
        this.$set(this.activeFilters, 'favorited', this.favoriteFilterEnabled);
      } else {
        this.$set(this.activeFilters, 'favorited', null);
      }
       
      this.disableInfiniteLoader = true;
      this.runSearch();
    },

    visitPage: function(pageUrl) {
      this.form.image_url = '';

      let data = {};
      data = this.parsedFilters;
      data.formData = this.form;

      if(pageUrl !== null) {
        this.$inertia.get(pageUrl, data, {
          preserveScroll: true,
        })
      }
    },

    getDateWithTime() {
      return this.form.post_date ? dayjs(this.form.post_date) : '';
    },

    searchClicked(type) {
      this.$set(this.activeFilters, type, this.nameFilter);
      this.runSearch();
    }, 

    addFilter(type, event) {
      this.$set(this.activeFilters, type, event.target.value);
      this.runSearch();
    },

    runSearch() {
      this.form.image_url = '';

      let data = {};
      data = this.parsedFilters;
      data.formData = this.form;

      this.$inertia.get(this.$route('scheduler.posts.create'), data, {
        preserveScroll: true,
        onFinish: () => {
          this.disableInfiniteLoader = false;
          this.$refs.infiniteLoaderMedia.stateChanger.loaded();
          this.$refs.infiniteLoaderMyMedia.stateChanger.loaded();
        },
      })
    },

    changeCaption(caption) {
      this.form.caption = caption;
    },

    changeDate(postingDate) {
      this.newDate = dayjs(postingDate).format('MM/DD');

      if(postingDate === 'Invalid Date') {
        this.form.post_date = '';
      } else {
        this.form.post_date = postingDate;
      }
    },

    async onSubmitPostNow() {
      this.openLoadingModal();
      this.form.post_date = dayjs().add(1, 'minute').format('YYYY/MM/DD HH:mm:ss ZZ');
      if(this.croppedImage) {
        let res = await fetch(this.croppedImage);
        let buf = await res.blob();
        let file = await new File([buf], 'image.png',{ type: "image/png" });


        return this.postUploadedMedia('image_file', file, 'image');
      } 

      if(this.videoFile) {
        return this.postUploadedMedia('video_file', this.videoFile, 'video');
      }

      if(this.form.video_url) {
        return this.$inertia.post(this.$route('scheduler.posts.store','video'), this.form, {
          onSuccess: () => this.loading = false,
          onFinish: () => this.loading = false,
        });
      }
      
      this.$inertia.post(this.$route('scheduler.posts.store','image'), this.form,
        {
          onSuccess: () => this.loading = false,
          onFinish: () => this.loading = false,
        });
    },

    async submitPost() {
      this.openLoadingModal();
      if(this.croppedImage) {
        let res = await fetch(this.croppedImage);
        let buf = await res.blob();
        let file = await new File([buf], 'image.png',{ type: "image/png" });


        return this.postUploadedMedia('image_file', file, 'image');
      } 

      if(this.videoFile) {
        return this.postUploadedMedia('video_file', this.videoFile, 'video');
      }

      if(this.form.video_url) {
        return this.$inertia.post(this.$route('scheduler.posts.store','video'), this.form, {
          onSuccess: () => this.loading = false,
          onFinish: () => this.loading = false,
        });
      }
      
      this.$inertia.post(this.$route('scheduler.posts.store','image'), this.form,
        {
          onSuccess: () => this.loading = false,
          onFinish: () => this.loading = false,
        });
    },

    async onSubmitSaveAsDraft() {
      this.openLoadingModal();
      if(this.croppedImage) {
        let res = await fetch(this.croppedImage);
        let buf = await res.blob();
        let file = await new File([buf], 'image.png',{ type: "image/png" });

        return this.postUploadedMedia('image_file', file, 'image', 'draft');
      } 

      if(this.videoFile) {
        return this.postUploadedMedia('video_file', this.videoFile, 'video', 'draft');
      }

      if(this.form.video_url) {
        return this.$inertia.post(this.$route('scheduler.posts.store','video'), {status: 'draft', ...this.form}, {
          onSuccess: () => this.loading = false,
          onFinish: () => this.loading = false,
        });
      }

      this.$inertia.post(this.$route('scheduler.posts.store','image'), {status: 'draft', ...this.form}, {
        onSuccess: () => this.loading = false,
        onFinish: () => this.loading = false,
      });
    },

    postUploadedMedia(mediaKey, value, postingType, status = null) {
        let formData = new FormData();
        
        formData.append(mediaKey, value);
        Object.keys(this.form).forEach((key) => { 
          formData.append(key, this.form[key]);
        }) 

        if(!status) {
          return this.$inertia.post(this.$route('scheduler.posts.store',postingType), formData,
          {
            onSuccess: () => this.loading = false,
            onFinish: () => this.loading = false,
          });
        }

        formData.append('status', status);
        return this.$inertia.post(this.$route('scheduler.posts.store',postingType), formData,
        {
          onSuccess: () => this.loading = false,
          onFinish: () => this.loading = false,
        });        
    },

    openLoadingModal() {
      let messageName = this.item && this.item.name ? this.item.name : 'selected media';
      this.loadingMessage = `Uploading ${messageName}`; 
      this.loading = true;
    },

    async changePhoto(url) {
      if(url) {
          try {
            this.loadingImageParse = true;
            
            let response = await fetch(`/api/v1/media/to-string?url=${url}`);
            let data = await response.json();

            this.imageSrc = data.base64;
            this.cropperModal = true;
          } catch (ex) {
            this.flash.error = 'A problem happened while getting the selected image';
          } finally {
            this.loadingImageParse = false;
          }
      }
    },

    changeVideo(payload) {
      if(!payload) {
        this.form.video_url = '';
        this.videoDuation = 0;
        this.videoAudioChannels = 0;
      }
      this.form.video_url = payload.url;
      this.videoDuation = payload.duration;
    },

    changeShowing(show) {
      if(show === 'Upload') {
        this.form.image_url = '';
      }

      if(show === 'Media' || show === 'MyMedia') {
        this.croppedImage = null;
        this.imageSrc = null;
        this.imageFile = null;
        this.uploadedVideoDuration = 0;
        this.uploadedVideoAudioChannels = 0;
        this.videoFile = '';
        this.videoSrc = '';
      }

      this.photos = show;

      if(this.$refs.infiniteLoaderMedia && this.media.links.next) {
        this.$refs.infiniteLoaderMedia.stateChanger.reset();
      }

      if(this.$refs.infiniteLoaderMyMedia && this.myMedia.links.next) {
        this.$refs.infiniteLoaderMyMedia.stateChanger.reset();
      }
    },

    showPhotos(payload) {
      this.item = payload['item'];
      this.photos = payload['show'];
    },

    disableButton() { 
      return (!this.form.image_url && !this.croppedImage && !this.form.video_url && !this.videoFile) || !this.activePages;
    },
    
    disableConfirmButton() { 
      return (!this.form.image_url && !this.croppedImage && !this.form.video_url && !this.videoFile) || !this.form.post_date || !this.activePages;
    },

    getError() {
      if(this.buttonOver && this.buttonOver === 'confirm') {
        if(!this.form.image_url && !this.croppedImage && !this.form.video_url && !this.videoFile) {
          return 'Please select an image or video from the left panel';
        } else if(!this.form.post_date) {
          return 'Please enter a date to make the post';
        } else if(this.activePages === 0) {
          return 'Please enter a page to make the post';
        }
      }

      if(!this.form.image_url && !this.croppedImage && !this.form.video_url && !this.videoFile) {
        return 'Please select an image or video from the left panel';
      }

      if(this.activePages === 0) {
        return 'Please enter a page to make the post';
      }

      return '';
    },

    showError(payload) {
      this.buttonOver = payload.enabled ? payload.button : null;
      this.passedOverButton = payload.enabled;
    },

    openCropperModal() {
      this.cropperModal = true;
    },

    closeCropperModal() {
      this.cropperModal = false;
      this.imageSrc = null;
    },

    changeSelectedPhoto() {
      this.deleteSelectedVideo();
      this.$refs['media-input'].click();
    },

    uploadMediaDrag(event){
      let files = event.dataTransfer.files;
      if(files[0].type.includes('video')) {
          
          this.videoFile = files[0];
          this.videoSrc = URL.createObjectURL(this.videoFile);
          this.getData(this.videoSrc);
        
          return;
        }

        var reader = new FileReader();
        reader.onload = async (e) => {
          this.imageSrc = e.target.result;
        };

        reader.readAsDataURL(files[0]);
        this.openCropperModal();
    },

    uploadMedia: function (event) {
      
      var reader = new FileReader();

      if (event.target.files && event.target.files[0]) {
        
        if(event.target.files[0].type.includes('video')) {
          
          this.videoFile = event.target.files[0];
          this.videoSrc = URL.createObjectURL(this.videoFile);
          this.getData(this.videoSrc);
        
          return;
        }

        var reader = new FileReader();
        reader.onload = async (e) => {
          this.imageSrc = e.target.result;
        };

        reader.readAsDataURL(event.target.files[0]);
        this.openCropperModal();
      }
    },

    getData(videoSource) {
            let audioCtx = new AudioContext(); 
            var request = new XMLHttpRequest();
            request.open('GET', videoSource , true);
            request.responseType = 'arraybuffer';

            request.onload = () => {
                var audioData = request.response;

                audioCtx.decodeAudioData(audioData, (buffer) => {
                    
                    this.uploadedVideoAudioChannels = buffer.numberOfChannels;
                    return buffer.numberOfChannels;
                })
            }
            request.send();
        },

    onImageCrop(image) {
      this.changeShowing('Upload');
      this.croppedImage = image;
      this.cropperModal = false;
    },

    deleteCropperdImage(){
      this.croppedImage = null;
    },

    deleteSelectedVideo(){
      this.videoFile = null;
      this.imageSrc = null;
      this.uploadedVideoDuration = 0;
      this.uploadedVideoAudioChannels = 0;
    },

    changePage(payload) {
      let provider = payload.provider;
      let selectedVideoDuration = this.uploadedVideoDuration > 0 ? this.uploadedVideoDuration : this.videoDuation;

      if (payload.active) {
        if(provider === 'facebook' && selectedVideoDuration > this.FACEBOOK_VIDEO_RESTRICTION) {
          this.alertText = 'The selected video is not postable on facebook';
          this.enableAlertModalShowing = true;
          this.openAlertModal = true;
          this.$inertia.put(this.$route('social-pages.update', { pageId: payload.pageId }), {'active': false});
          return;
        }

        if(provider === 'instagram' && (selectedVideoDuration > this.INSTAGRAM_VIDEO_RESTRICTION || this.videoAudioChannels > 2 || this.uploadedVideoAudioChannels > 2)) {
          this.alertText = 'The selected video is not postable on instagram';
          this.enableAlertModalShowing = true;
          this.openAlertModal = true;
          this.$inertia.put(this.$route('social-pages.update', { pageId: payload.pageId }), {'active': false});
          return;
        }

        if (provider === 'facebook' && this.areInstagramActivePages) {
          if(!this.areFacebookActivePages) {
            this.enableAlertModalShowing = true;
          }
          this.alertText = 'By adding instagram, any photo and video restrictions will also apply to Facebook';
          this.openAlertModal = true;
        }

        if (provider === 'instagram' && this.areFacebookActivePages) {
          if(!this.areInstagramActivePages) {
            this.enableAlertModalShowing = true;
          }
          this.alertText = 'By adding instagram, any photo and video restrictions will also apply to Facebook';
          this.openAlertModal = true;
        }
      }

      this.$inertia.put(this.$route('social-pages.update', { pageId: payload.pageId }), {'active': payload.active});
    },

    closeAlertModal() {
      this.openAlertModal = false;
      this.enableAlertModalShowing = false;
    },

    showVideoNotSelectibleMessage() {
      this.flash.error = 'The selected video does not fulfills the restrictions for the selected pages';
    },

    setUploadedVideoDuration(event) {
      this.uploadedVideoDuration = event.target.duration / 60;
    },

    removeInstagramAccounts() {
      this.instagramActivePages.forEach(page => 
        this.$inertia.put(this.$route('social-pages.update', { pageId: page.id }), {'active': false}));
    },

    changeVideoAudioChannels(audioChannels) {
      this.videoAudioChannels = audioChannels;
    }
  },

  computed: {
    parsedFilters() {
      const filters = {};

      Object.keys(this.activeFilters).forEach(key => {
        if (this.activeFilters[key] === null) {
          delete this.activeFilters[key];
          return;
        }

        let keyName = `filter[${key}]`;
        filters[keyName] = this.activeFilters[key];
      });

      return filters;
    },

    instagramActivePages() {
      let activePages = this.pages.filter(page => page.active === 1);
      return activePages.filter(page => page.provider === 'instagram'); 
    },

    areInstagramActivePages() {
      return this.instagramActivePages.length > 0; 
    },

    areFacebookActivePages() {
      let activePages = this.pages.filter(page => page.active === 1);
      return activePages.filter(page => page.provider === 'facebook').length > 0; 
    },

    activePages() {
      let activePages = this.pages.filter(page => page.active === 1);
      return activePages.length > 0; 
    },

    videoRestriction() {
      if(this.areInstagramActivePages) {
        return {duration: this.INSTAGRAM_VIDEO_RESTRICTION, maxAudioChannels: 2};
      }

      if(this.areFacebookActivePages) {
        return {duration: this.FACEBOOK_VIDEO_RESTRICTION, maxAudioChannels: 100};
      } 
      
      return {duration: this.DEFAULT_VIDEO_RESTRICTION, maxAudioChannels: 100};
    },
  },

  watch: {
      flash: {
        handler(flash) {
          if (flash.success && flash.success !== '') {
            this.$toast.success(flash.success);
          }
          if (flash.error && flash.error !== '') {
           this.$toast.error(flash.error);
           this.flash.error = '';
          }
        },
        deep: true,
      },
      media(media) {
        media.data.forEach(item => {
          const index = this.allMedia.findIndex(existingItem => existingItem.id === item.id);
          if (index === -1) {
            this.allMedia.push(item);
          }
        })
      },
      myMedia(media) {
        media.data.forEach(item => {
          const index = this.allMyMedia.findIndex(existingItem => existingItem.id === item.id);
          if (index === -1) {
            this.allMyMedia.push(item);
          }
        })
      }
  },
}
</script>

<style lang="css" scoped>
  .mt-50 {
    margin-top: 11rem;
  }

 
</style>